import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "./images/bpad-logo.svg";
import "./Navbar.css";

export default function Navbar() {
    const { pathname } = useLocation();

    const isLoginPage = pathname === "/login";
    const isJoin = pathname.startsWith("/join"); // or stricter: /^\/join(?:\/|$)/.test(pathname)

    const navClasses = ["nav"];
    if (isLoginPage) navClasses.push("nav-login");
    if (isJoin) navClasses.push("nav-join");

    return (
        <nav className={navClasses.join(" ")}>
            <Link to="/">
                <img src={logo} className="logo" alt="BPAD Logo" />
            </Link>
            <ul className="nav-links">
                <li><Link to="/">HOME</Link></li>
                <li><Link to="/about">ABOUT</Link></li>
                <li><Link to="/join">JOIN</Link></li>
                <li><Link to="/executive-board">EXECUTIVE BOARD</Link></li>
                <li><Link to="/login">LOGIN</Link></li>
            </ul>
        </nav>
    );
}